import { useEffect } from 'preact/hooks';

import { useDangerousLatestValueRef } from '@/hooks/useLatestValueRef';

interface TourAutoAdvanceSlotProps {
  delayMs: number;
  onAdvance: () => void;
}

/**
 * Headless: fires `onAdvance` after `delayMs`. Mounted only while an autoAdvance config
 * resolves, so a step whose `when` does not match the current path has no timer at all —
 * being off-path stops the countdown without any explicit pause logic.
 *
 * The runner keys this by step id, so moving between steps remounts it and restarts the timer.
 * `onAdvance` is held in a latest-value ref so unrelated parent rerenders do not reset the timer.
 */
const TourAutoAdvanceSlot = ({ delayMs, onAdvance }: TourAutoAdvanceSlotProps) => {
  const onAdvanceRef = useDangerousLatestValueRef(onAdvance);

  useEffect(() => {
    const timer = setTimeout(() => onAdvanceRef.current(), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs, onAdvanceRef]);

  return null;
};

export default TourAutoAdvanceSlot;
